import React from "react";
import { useLang } from "@/i18n";
import { ShowcaseGrid } from "@/components/ShowcaseGrid";

/**
 * The Home page "THE TIMELINE" section — now a direct grid of client
 * showcases rather than a compact list of project cards. Users pick a
 * client card to see every piece we made for them.
 */
export const WorkSection = React.forwardRef((props, ref) => {
  const { t } = useLang();
  return (
    <section
      ref={ref}
      id="work"
      data-testid="work-section"
      className="relative mx-auto max-w-[1600px] px-6 md:px-12 py-24 md:py-36"
    >
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between mb-16">
        <div>
          <span className="font-mono text-[11px] tracking-[0.35em] uppercase text-bone/40">
            Selected work
          </span>
          <h2 className="mt-4 font-display text-6xl md:text-8xl font-semibold uppercase tighter leading-[0.85] text-bone">
            {t.work.title}
          </h2>
          <p className="mt-6 max-w-xl font-body font-light text-bone/60 leading-relaxed">
            {t.work.intro} — organised by client. Pick a showcase to see every piece we made together.
          </p>
        </div>
      </div>

      <ShowcaseGrid />
    </section>
  );
});

WorkSection.displayName = "WorkSection";
